import { observable } from 'mobx';
import { IGeneralKeys } from '../../views/product-filters/IProductFilters';
import { Filter } from './Filter';

export class FilterPriceRange extends Filter {
    @observable public minValue: string;
    @observable public maxValue: string;
    @observable public isRange: boolean;

    constructor(filterJson: IGeneralKeys, category: string, isDefaultSelected: boolean = false) {
        super(filterJson, category, isDefaultSelected);
    }

    public passes(comparisonValue: string[]): boolean {
        const comparisonValueToNumber = comparisonValue.map(Number);

        return (
            comparisonValueToNumber &&
            comparisonValueToNumber.some(
                price => price >= Number(this.minValue) && price < Number(this.maxValue)
            )
        );
    }
}
